export default __webpack_public_path__ + "static/media/news107.bb9e4fa7.jpg";